module.exports = __webpack_public_path__ + "img/back_active1.06237c7a.png";